import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { useAuthedApi } from "../lib/api";
import Overview from "../components/admin/Overview";
import AdminListings from "../components/admin/AdminListings";
import AdminDealers from "../components/admin/AdminDealers";
import AdminLeads from "../components/admin/AdminLeads";
import AdminUsers from "../components/admin/AdminUsers";
import AdminBanners from "../components/admin/AdminBanners";
import AdminHero from "../components/admin/AdminHero";
import AdminFilters from "../components/admin/AdminFilters";
import AdminStates from "../components/admin/AdminStates";
import BrandingForm from "../components/admin/BrandingForm";
import OwnerEditor from "../components/OwnerEditor";
import AdvertiseEditor from "../components/AdvertiseEditor";
import axios from "axios";
import { API } from "../lib/api";
import BackButton from "../components/BackButton";

const TABS = [["overview", "Overview"], ["branding", "Site Branding"], ["hero", "Homepage Banners"], ["states", "States Banner"], ["listings", "Listings"], ["banners", "City Banners"], ["filters", "Filters"], ["dealers", "Dealers & Verification"], ["leads", "Enquiries & Offers"], ["users", "Users"]];

function BrandingTab() {
  const [owner, setOwner] = useState(false);
  const [ads, setAds] = useState(false);
  return (
    <div className="space-y-4 max-w-3xl">
      <BrandingForm />
      <div className="lux-card p-4 flex items-center justify-between gap-3"><span className="text-sm">Advertise With Us page — heading, text, ad options & prices</span><button className="btn-outline text-sm" onClick={() => axios.get(`${API}/settings/advertise`).then((r) => setAds(r.data))} data-testid="admin-advertise-edit">Edit Advertise page</button></div>
      {ads && <AdvertiseEditor value={ads} onClose={() => setAds(false)} />}
      <div className="lux-card p-4 flex items-center justify-between gap-3"><span className="text-sm">Invest With Us page — owner profile & photo</span><button className="btn-outline text-sm" onClick={() => setOwner(true)} data-testid="admin-owner-edit">Edit owner profile</button></div>
      {owner && <OwnerEditor onClose={() => setOwner(false)} />}
    </div>
  );
}

export default function Admin() {
  const api = useAuthedApi();
  const [params, setParams] = useSearchParams();
  const [me, setMe] = useState(null);
  const tab = params.get("tab") || "overview";
  useEffect(() => { api("get", "/me").then(setMe).catch(() => setMe({ role: "none" })); }, [api]);

  if (!me) return <div className="pt-40 text-center text-gray-500">Loading...</div>;
  if (me.role !== "admin") return (
    <div className="pt-40 max-w-md mx-auto text-center space-y-4" data-testid="admin-forbidden">
      <ShieldAlert className="w-12 h-12 text-[#D4AF37] mx-auto" />
      <h1 className="font-display text-4xl">Admins only</h1>
      <p className="text-gray-400">This area is reserved for the site owner.</p>
      <Link to="/" className="btn-outline">Back to home</Link>
    </div>
  );

  const trig = "data-[state=active]:text-black data-[state=active]:bg-[#D4AF37] rounded-full px-4 py-2 text-xs sm:text-sm text-gray-300";
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32" data-testid="admin-page">
      <BackButton className="mb-4" />
      <p className="eyebrow mb-3">Owner console · {me.email}</p>
      <h1 className="font-display text-5xl sm:text-6xl mb-10">Admin Panel</h1>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-[#111319] border gold-line rounded-full p-1 h-auto flex-wrap justify-start mb-8">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className={trig} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="overview"><Overview onGo={(t) => setParams({ tab: t })} /></TabsContent>
        <TabsContent value="listings"><AdminListings /></TabsContent>
        <TabsContent value="banners"><AdminBanners /></TabsContent>
        <TabsContent value="hero"><AdminHero /></TabsContent>
        <TabsContent value="branding"><BrandingTab /></TabsContent>
        <TabsContent value="states"><AdminStates /></TabsContent>
        <TabsContent value="filters"><AdminFilters /></TabsContent>
        <TabsContent value="dealers"><AdminDealers /></TabsContent>
        <TabsContent value="leads"><AdminLeads /></TabsContent>
        <TabsContent value="users"><AdminUsers /></TabsContent>
      </Tabs>
    </div>
  );
}
